import Vue from 'vue'
import Router from 'vue-router'
// import MainIndex from '@/components/MainIndex'
import Layout from '@/layout'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/home',
      children: [
        {
          path: '',
          component: () => import('../view/home/index'),
          name: 'home',
        }
      ]
    },
    {
      path: '/product',
      component: Layout,
      redirect: '/product',
      children: [
        {
          path: '',
          component: () => import('../view/product/index'),
          name: 'product',
        }
      ]
    },
   
    {
      path: '/tel',
      component: Layout,
      redirect: '/tel',
      children: [
        {
          path: '',
          component: () => import('../view/tel/index'),
          name: 'tel',
        }
      ]
    },
    {
      path: '/about',
      component: Layout,
      redirect: '/about',
      children: [
        {
          path: '',
          component: () => import('../view/about/index'),
          name: 'about',
        }
      ]
    },
    
   
   
   
   
   
    // {
    //   path: '/jobsDetail/:id(\\d+)',
    //   component: () => import('../view/jobDetail/index'),
    //   name: 'jobsDetail',
    // },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js